import React from 'react';
import Typography from '@mui/material/Typography';
import { InstallationStatus } from '../types';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { SxProps, Theme } from '@mui/material/styles';
import { useIsSmallScreen } from '../../../system/SystemMediaQueriesProvider';

interface StatusMessageProps {
  status?: InstallationStatus;
  message?: string | null;
  plain?: boolean; ///* Return a plain one-line component instead of the full message box */
  sx?: SxProps<Theme>;
}

export function StatusMessage(props: StatusMessageProps) {
  const { status, message, plain, sx } = props;
  const isSmallScreen = useIsSmallScreen();
  const myMessage =
    status === InstallationStatus.SCAN_IN_PROGRESS
      ? 'Align Barcode Within Scan Frame'
      : message;

  let title: string;
  switch (status) {
    case InstallationStatus.READY_TO_INSTALL:
      title = `This device is ready for installation.`;
      break;
    case InstallationStatus.SCAN_IN_PROGRESS:
      title = `Scanning QR code ...`;
      break;
    case InstallationStatus.SCAN_SUCCESSFUL:
      title = `QR code scan successful.  Press 'JOIN DEVICE' to proceed with the installation`;
      break;
    case InstallationStatus.NETWORK_OPEN_REQUESTED:
      title = `Requesting network connection ...`;
      break;
    case InstallationStatus.NETWORK_OPEN:
      title = `The network is open. Press the 'JOIN' button on the device.`;
      break;
    case InstallationStatus.NETWORK_OPEN_FAILED:
      title = `The network failed to open.  Make sure a working Source is installed.`;
      break;
    case InstallationStatus.INSTALLATION_SUCCESSFUL:
      title = `This device has been installed successfully.`;
      break;
    case InstallationStatus.INSTALLATION_FAILED:
      title = `The device has failed to join the network.`;
      break;
    case InstallationStatus.CONFIGURATION_IN_PROGRESS:
      title = `The device has successfully joined the network.  Please stand by while final configuration is completed.`;
      break;
    case InstallationStatus.CONFIGURATION_FAILED:
      title = `Device configuration failed.  Please try again.`;
      break;
    case InstallationStatus.READY_TO_REPLACE:
      title = `To proceed with device replacement, either scan the QR code or enter the device EUID`;
      break;
    case InstallationStatus.VALIDATE_ID_IN_PROGRESS:
      title = `Scan the QR code of the device to validate the ID.`;
      break;
    case InstallationStatus.VALIDATE_ID_SUCCESSFUL:
      title = `The device ID has been validated successfully.`;
      break;
    case InstallationStatus.VALIDATE_ID_FAILED:
      title = `The device ID has failed to validate.`;
      break;
    default:
      title = `Error - Unknown Installation Status`;
  }

  return plain || isSmallScreen ? (
    <Typography variant={'caption'} sx={{ fontSize: '1rem', ...sx }}>
      {status === InstallationStatus.SCAN_IN_PROGRESS ? (
        myMessage
      ) : (
        <>
          <strong>Status:</strong> {(myMessage || title) ?? '?'} ({status})
        </>
      )}
    </Typography>
  ) : (
    <Box
      sx={{
        padding: isSmallScreen ? 1 : 2,
        margin: isSmallScreen ? 1 : 0,
        border: '1px solid',
        borderRadius: '8px',
        borderColor: 'gray',
        background: '#eee',
      }}
    >
      {title ? (
        <Typography align={'center'} variant={isSmallScreen ? 'h5' : 'h3'}>
          {title}
        </Typography>
      ) : (
        <></>
      )}
      {message ? (
        <>
          <Divider
            sx={{ borderBottom: 0, marginBottom: isSmallScreen ? 1 : 3 }}
          />
          <Typography align={'center'} variant={isSmallScreen ? 'h5' : 'h4'}>
            {myMessage}
          </Typography>
        </>
      ) : (
        <></>
      )}
    </Box>
  );
}
